export const LOCAL_STORAGE_KEY_JWT = "local_storage_key_jwt"
export const LOCAL_STORAGE_KEY_ERP_USER_NAME = "local_storage_key_erp_user_name"
export const LOCAL_STORAGE_KEY_ERP_USER_UID = "local_storage_key_erp_user_uid"